import { UIHeading2 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './EmptyListingSuggestionsLayout.css';

interface IEmptyListingSuggestionsLayoutProps {
  className?: string;
  children: React.ReactNode;
}

export const EmptyListingSuggestionsLayout = ({ className, children }: IEmptyListingSuggestionsLayoutProps) => (
  <section className={cn(styles['root'], className)} data-testid="EmptyListingSuggestions">
    <div className={styles['title']}>
      <UIHeading2>Вам могут подойти</UIHeading2>
    </div>
    <div className={styles['list']}>{children}</div>
  </section>
);
